import { render, staticRenderFns } from "./SearchPagination.vue?vue&type=template&id=c5d3cea6&scoped=true"
import script from "./SearchPagination.vue?vue&type=script&lang=js"
export * from "./SearchPagination.vue?vue&type=script&lang=js"
import style0 from "./SearchPagination.vue?vue&type=style&index=0&id=c5d3cea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d3cea6",
  null
  
)

export default component.exports